
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface FilterButtonsProps {
  currentFilter?: string;
  setFilter: (filter: string) => void;
  filter?: string;
  className?: string;
  style?: React.CSSProperties;
}

const FilterButtons = ({ filter, currentFilter, setFilter, className = "", style }: FilterButtonsProps) => {
  const activeFilter = currentFilter || filter || "all";
  const { theme } = useThemeConfig();

  const getButtonStyle = (key: string) => {
    const isActive = activeFilter === key;
    return {
      backgroundColor: isActive ? theme.primaryColor : theme.backgroundColor,
      color: isActive ? theme.textPrimaryColor : theme.textColor,
      fontWeight: isActive ? 'bold' : undefined,
      borderColor: theme.primaryColor,
      '--btn-bg-hover': theme.primaryColor,
    } as React.CSSProperties;
  };

  return (
    <div className={`flex space-x-2 mt-2 ${className}`}>
      <Button
        size="sm"
        variant="outline"
        onClick={() => setFilter("all")}
        className="hover:bg-[var(--btn-bg-hover)]"
        style={{ ...style, ...getButtonStyle("all") }}
      >
        Tutti
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={() => setFilter("active")}
        className="hover:bg-[var(--btn-bg-hover)]"
        style={{ ...style, ...getButtonStyle("active") }}
      >
        Da comprare
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={() => setFilter("completed")}
        className="hover:bg-[var(--btn-bg-hover)]"
        style={{ ...style, ...getButtonStyle("completed") }}
      >
        Comprati
      </Button>
    </div>
  );
};

export default FilterButtons;
